import { render, staticRenderFns } from "./templateEditDialog.vue?vue&type=template&id=91b956a8&"
import script from "./templateEditDialog.vue?vue&type=script&lang=js&"
export * from "./templateEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./templateEditDialog.vue?vue&type=style&index=0&id=91b956a8&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports